import * as yup from "yup";

export const IGNORE_ERROR = "IGNORE";

export const CALCULATION_RESIDUAL_VALUE_EDIT_FORM_SCHEMA = yup.object().shape({
  name: yup.string().required('Molimo Vas da unesite naziv'),
});

